import { removeCitationName } from "../lib/cvDataUtilities.js";
import {
  escapeHtml,
  getProp,
  setCitatonPrefs
} from "../lib/frontendUtilities.js";
import { findCVNames } from "../lib/pubMed.js";
import { getKey } from "../lib/utilities.js";

export default function (opts) {
  opts = opts || {};

  return function ({
    contextMethods,
    contextConstants,
    contextState,
    backend
  }) {
    let { refreshSection, checkSave } = contextMethods;
    let { cvOwner } = contextConstants;
    let { canEdit, newDef, pmidList } = contextState;

    // -- Citation Names --

    $("#highlightNameList").empty();
    var citationNames = getKey(newDef, "citationName", "")
      .split(";")
      .filter((n) => n != "");

    newDef.citationName = citationNames.join(";");
    citationNames.map(function (highlightName) {
      $("#highlightNameList").append(
        $(
          "" +
            '<div class="btn btn-default ' +
            (!canEdit ? "" : "removeHighlightName") +
            '" data-name="' +
            escapeHtml(highlightName) +
            '" style="margin-bottom: 5px;margin-right: 5px;">' +
            "  <span>" +
            escapeHtml(highlightName) +
            "</span>" +
            (!canEdit
              ? ""
              : '  <span class="glyphicon glyphicon-remove" style="margin-left: 5px;"></span>') +
            "</div>"
        )
      );
    });
    $(".removeHighlightName")
      .unbind("click")
      .click(function () {
        var name = getProp(this, "name");
        newDef.citationName = getKey(newDef, "citationName", "")
          .split(";")
          .filter((n) => n != name)
          .join(";");
        checkSave();
        refreshSection();
      });

    var possibleNames = findCVNames(newDef, pmidList).possibleNames;
    $("#highlightSuggestedNames").toggle(possibleNames.length > 0);
    $("#highlightSuggestedNames").empty();
    possibleNames.map(function (name) {
      $("#highlightSuggestedNames").append(
        $(
          '<div class="btn btn-primary addSearchName" data-name="' +
            escapeHtml(name) +
            '" style="margin-bottom: 5px;margin-right: 5px;">' +
            '  <span class="glyphicon glyphicon-plus" style="margin-right: 5px;"></span><span>' +
            escapeHtml(name) +
            "</span> " +
            "</div>" +
            '<div class="btn btn-primary removeSuggestedName" data-name="' +
            escapeHtml(name) +
            '" style="margin-bottom: 5px;margin-left: -10px; margin-right:5px;">' +
            '<span class="glyphicon glyphicon-minus"  style="width:10px; margin-left: -10px;"></span></div>'
        )
      );
    });
    $("#highlightSuggestedNames")
      .find(".addSearchName")
      .click(function () {
        var name = getProp(this, "name");
        newDef["citationName"] = newDef["citationName"]
          .split(";")
          .concat([name])
          .join(";");
        checkSave();
        refreshSection();
      });
    $("#highlightSuggestedNames")
      .find(".removeSuggestedName")
      .click(function () {
        var name = getProp(this, "name");
        removeCitationName(name, newDef);
        checkSave();
        refreshSection();
      });

    // -- First Names --

    $("#highlightFirstNameList").empty();
    var firstNames = getKey(newDef, "firstNames", "")
      .split(";")
      .filter((n) => n != "");

    var fullName = cvOwner.name.split(",")[0];
    var names = fullName.split(/ |\./).filter(function (name) {
      return name.length > 1;
    });
    if (firstNames.length == 0 && names.length > 0) firstNames.push(names[0]);

    newDef.firstNames = firstNames.join(";");
    firstNames.map(function (highlightName) {
      $("#highlightFirstNameList").append(
        $(
          "" +
            '<div class="btn btn-default ' +
            (!canEdit ? "" : "removeHighlightFirstName") +
            '" data-name="' +
            escapeHtml(highlightName) +
            '" style="margin-bottom: 5px;margin-right: 5px;">' +
            "  <span>" +
            escapeHtml(highlightName) +
            "</span>" +
            (!canEdit
              ? ""
              : '  <span class="glyphicon glyphicon-remove" style="margin-left: 5px;"></span>') +
            "</div>"
        )
      );
    });
    $(".removeHighlightFirstName")
      .unbind("click")
      .click(function () {
        var name = getProp(this, "name");
        newDef.firstNames = getKey(newDef, "firstNames", "")
          .split(";")
          .filter((n) => n != name)
          .join(";");
        checkSave();
        refreshSection();
      });

    var possibleFirstNames = findCVNames(newDef, pmidList).possibleFirstNames;
    $("#highlightSuggestedFirstNames").toggle(possibleFirstNames.length > 0);
    $("#highlightSuggestedFirstNames").empty();
    possibleFirstNames.map(function (name) {
      $("#highlightSuggestedFirstNames").append(
        $(
          '<div class="btn btn-primary addSearchFirstName" data-name="' +
            escapeHtml(name) +
            '" style="margin-bottom: 5px;margin-right: 5px;">' +
            '  <span class="glyphicon glyphicon-plus" style="margin-right: 5px;"></span><span>' +
            escapeHtml(name) +
            "</span> " +
            "</div>"
        )
      );
    });
    $("#highlightSuggestedFirstNames")
      .find(".addSearchFirstName")
      .click(function () {
        var name = getProp(this, "name");
        newDef["firstNames"] = newDef["firstNames"]
          .split(";")
          .concat([name])
          .join(";");
        checkSave();
        refreshSection();
      });

    $("#highlightInput").parent().parent().toggle(canEdit);

    if (newDef["asterix"] == null) newDef["asterix"] = "* Co-author, ** Mentee";
    $("#asterixInput").prop("disabled", !canEdit);
    $("#asterixInput").val(newDef["asterix"] || "");

    $("#orcidInput")
      .unbind("input")
      .on("input", function () {
        var name = $("#orcidInput").val().trim();
        newDef["orcid"] = name;
        if (!!opts.requireORCID)
          $("#orcidInput")
            .parent()
            .toggleClass(
              "has-error",
              (newDef["orcid"] || "").trim().length == 0
            );
        checkSave();
      });

    if (!!opts.requireORCID)
      $("#orcidInput")
        .parent()
        .toggleClass("has-error", (newDef["orcid"] || "").trim().length == 0);
    $("#orcidInput").val(newDef["orcid"] || "");
    $("#orcidInput").prop("disabled", !canEdit);

    $("#ncbiInput")
      .parent()
      .css("display", !!opts.ncbi ? "inline-block" : "none");
    if (!!opts.ncbi) {
      $("#ncbiInput")
        .unbind("input")
        .on("input", function () {
          var name = $("#ncbiInput").val().trim();
          newDef["ncbi"] = name;
          checkSave();
        });

      $("#ncbiInput").val(newDef["ncbi"] || "");
      $("#ncbiInput").prop("disabled", !canEdit);
    }

    // Citation preferences
    cvOwner = setCitatonPrefs(contextConstants, backend);

    $("#pubmedImport").toggle(!!canEdit);
    $("#highlightSection").show();
  };
}
